import { render } from "./contactdemo.vue?vue&type=template&id=4c6fbab4&scoped=true"
import script from "./contactdemo.vue?vue&type=script&lang=js"
export * from "./contactdemo.vue?vue&type=script&lang=js"

import "./contactdemo.vue?vue&type=style&index=0&id=4c6fbab4&lang=css"
import "./contactdemo.vue?vue&type=style&index=1&id=4c6fbab4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6fbab4"]])

export default __exports__